"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../utils");
var _ListItemContent = _interopRequireDefault(require("./ListItemContent"));
var _ListItemMark = _interopRequireDefault(require("./ListItemMark"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _ThemeProvider = require("../ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);
const selectItemBlockStyles = _ref => {
  let {
    interItemMargin
  } = _ref;
  return {
    marginBottom: interItemMargin
  };
};
const selectDividerStyles = _ref2 => {
  let {
    dividerColor,
    dividerSize,
    interItemMarginWithDivider
  } = _ref2;
  return {
    borderBottomWidth: dividerSize,
    borderColor: dividerColor,
    marginBottom: interItemMarginWithDivider,
    paddingBottom: interItemMarginWithDivider
  };
};

/**
 * ListItem is responsible for rendering icon or a bullet as side item
 */
const ListItemBase = /*#__PURE__*/_react.default.forwardRef((_ref3, ref) => {
  let {
    tokens,
    icon,
    iconColor,
    iconSize,
    showDivider,
    children,
    title,
    isLastItem,
    accessibilityRole = _Platform.default.select({
      web: 'listitem',
      default: undefined
    }),
    ...rest
  } = _ref3;
  const themeTokens = typeof tokens === 'function' ? tokens() : tokens;
  const itemBlockStyles = selectItemBlockStyles(themeTokens);
  const dividerStyles = selectDividerStyles(themeTokens);
  const {
    iconMarginTop,
    itemIconSize
  } = themeTokens;
  let adjustedIconMarginTop = iconMarginTop;
  const {
    fontSize,
    lineHeight: lineHeightRatio
  } = (0, _ThemeProvider.useThemeTokens)('Typography', {}, {
    size: 'h4',
    bold: true
  });
  if (title) {
    adjustedIconMarginTop = (fontSize * lineHeightRatio - itemIconSize) / 2;
  }
  /**
   * Function responsible returning styling, in case the item is the last shouldn't
   * add extra margin on the bottom, if "showDivider" is true it should add a divider
   * and custom margin and padding, otherwise just adds a margin to the bottom
   */
  const getContainerStyle = () => {
    if (isLastItem) {
      return undefined;
    }
    if (showDivider) {
      return dividerStyles;
    }
    return itemBlockStyles;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    ref: ref,
    style: [staticStyles.container, getContainerStyle()],
    accessibilityRole: accessibilityRole,
    ...selectProps(rest),
    children: typeof children === 'function' ? children({
      tokens,
      icon,
      iconColor,
      iconSize,
      isLastItem
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
      style: staticStyles.container,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemMark.default, {
        tokens: {
          ...tokens,
          iconMarginTop: adjustedIconMarginTop
        },
        icon: icon,
        iconColor: iconColor,
        iconSize: iconSize
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
        style: staticStyles.titleAndContentContainer,
        children: [Boolean(title) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: {
            size: 'h4',
            bold: true
          },
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemContent.default, {
          tokens: tokens,
          children: children
        })]
      })]
    })
  });
});
ListItemBase.displayName = 'ListItem';
const staticStyles = _StyleSheet.default.create({
  container: {
    flex: 1,
    flexDirection: 'row'
  },
  titleAndContentContainer: {
    flexDirection: 'column',
    flexShrink: 1,
    flexGrow: 1
  }
});
ListItemBase.propTypes = {
  ...selectedSystemPropTypes,
  tokens: (0, _utils.getTokensPropType)('List'),
  variant: _utils.variantProp.propType,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
  /**
   * Renders side item icon
   */
  icon: _propTypes.default.elementType,
  /**
   * Will set display icon color
   */
  iconColor: _propTypes.default.string,
  /**
   * Allow the user define the icon size if not defined the theme's file
   */
  iconSize: _propTypes.default.number,
  /**
   * @ignore
   * Defined by parent if it's last item on the list
   */
  isLastItem: _propTypes.default.bool,
  /**
   * @ignore
   * In case it is not the last item allow display divider
   */
  showDivider: _propTypes.default.bool
};
var _default = exports.default = ListItemBase;